if (!window.__productGalleryGridOverrideLoaded) {
  window.__productGalleryGridOverrideLoaded = true;

  const originalScrollIntoView = Element.prototype.scrollIntoView;

  const isGridGallery = (gallery) => {
    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return false;
    // Checks if the carousel is grid-like (scrollWidth equals clientWidth usually implies stacking/grid)
    return Math.round(carousel.scrollWidth) === Math.round(carousel.clientWidth);
  };

  const moveMediaToFirstPosition = (galleryMedia) => {
    const gallery = galleryMedia.closest('product-gallery');
    if (!gallery) return;

    const carousel = gallery.querySelector('.product-gallery__carousel');
    if (!carousel) return;

    const currentScroll = window.scrollY;

    // Move the DOM element to the start of the list
    if (carousel.firstElementChild !== galleryMedia) {
      carousel.prepend(galleryMedia);
    }

    // Update classes for visual indication
    gallery.querySelectorAll('.product-gallery__media').forEach((media) => {
      media.classList.toggle('is-initial', media === galleryMedia);
    });

    // Update thumbnails active state
    gallery
      .querySelectorAll('.product-gallery__thumbnail-list .scroll-marker')
      .forEach((button) => {
        const thumbMediaId = button.dataset?.mediaId;
        if (!thumbMediaId) return;
        button.setAttribute('aria-current', thumbMediaId === galleryMedia.dataset.mediaId ? 'true' : 'false');
      });

    // Restore scroll position to prevent jumping
    requestAnimationFrame(() => window.scrollTo({ top: currentScroll }));
  };

  // --- NEW FEATURE: Handle Initial Page Load ---
  const handleInitialLoad = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');

    if (!variantId) return;

    // Helper to reliably find media ID from product data
    const getMediaId = async () => {
      // 1. Try global window.product (Fastest)
      if (window.product && window.product.variants) {
        const v = window.product.variants.find(v => v.id == variantId);
        if (v && v.featured_media) return v.featured_media.id;
      }

      // 2. Try common JSON script tags (Common in themes)
      const jsonScripts = document.querySelectorAll('[type="application/json"][data-product-json]');
      for (const script of jsonScripts) {
        try {
          const data = JSON.parse(script.textContent);
          const product = data.product || data;
          if (product && product.variants) {
            const v = product.variants.find(v => v.id == variantId);
            if (v && v.featured_media) return v.featured_media.id;
          }
        } catch (e) {
          // Ignore parse errors
        }
      }

      // 3. Fallback: Fetch product JSON from Shopify (Most Robust)
      // This guarantees we get the data even if global variables are missing
      try {
        const res = await fetch(window.location.pathname + '.js');
        if (res.ok) {
          const product = await res.json();
          const v = product.variants.find(v => v.id == variantId);
          if (v && v.featured_media) return v.featured_media.id;
        }
      } catch (e) {
        console.error('Error fetching product data:', e);
      }
      
      return null;
    };

    const mediaId = await getMediaId();
    if (!mediaId) return;

    // Retry loop: Wait for the gallery element to exist in the DOM
    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      
      const targetMedia = document.querySelector(`.product-gallery__media[data-media-id="${mediaId}"]`);
      
      if (targetMedia) {
        const gallery = targetMedia.closest('product-gallery');
        if (gallery) {
           // Check screen size to determine behavior
           const isMobile = window.matchMedia('(max-width: 768px)').matches;

           if (isMobile) {
             // Mobile: Standard scroll behavior (slides to the image)
             originalScrollIntoView.call(targetMedia, { behavior: 'smooth', inline: 'center', block: 'nearest' });
           } else {
             // Desktop: Move the DOM element to the first position
             moveMediaToFirstPosition(targetMedia);
           }
           
           clearInterval(interval);
        }
      }
      
      if (attempts > 20) clearInterval(interval); 
    }, 100);
  };

  // Override standard scrollIntoView to catch theme interactions
  Element.prototype.scrollIntoView = function scrollIntoViewOverride(options) {
    if (
      this?.classList?.contains('product-gallery__media') &&
      this.closest('product-gallery') &&
      isGridGallery(this.closest('product-gallery'))
    ) {
      moveMediaToFirstPosition(this);
      return;
    }

    return originalScrollIntoView.call(this, options);
  };

  // Run initial check on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleInitialLoad);
  } else {
    handleInitialLoad();
  }

  document.addEventListener('shopify:section:load', () => {
    // Re-run check if a section is reloaded via Shopify Editor or dynamic interaction
    handleInitialLoad();
  });
}